import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";


const API_LOGIN     = "/api/auth";
const API_LOGOUT    = "/logout";
const API_REGISTER  = "/api/auth";

const msalConfig = {
    auth: {
        // clientId: "3f903ee0-f8be-4089-a805-95adeb5bde81",
        // authority: "https://login.microsoftonline.com/20d2c17f-0ae6-4fe8-8ecf-870f7d30f0ef/oauth2/v2.0/authorize",
        // redirectUri: "http://95.235.176.80:3000",
        clientId: "a62f8970-a3c8-480f-a63d-bca5728acbf7", 
        authority: "https://login.microsoftonline.com/20d2c17f-0ae6-4fe8-8ecf-870fd730f0ef", 
        redirectUri: "http://95.235.176.80:3000", 
    },
};

const msalInstance = new PublicClientApplication(msalConfig);


export async function loginAndGetToken() {
    try {
        const loginResponse = await msalInstance.loginPopup({
            scopes: ["Mail.Send", "User.Read"],
        });

        const account = msalInstance.getActiveAccount() || loginResponse.account;

        const tokenResponse = await msalInstance.acquireTokenSilent({
            scopes: ["Mail.Send", "User.Read"],
            account,
        });

        return tokenResponse.accessToken;
    } catch (error) {
        console.error("Errore durante il login o il recupero del token:", error);
        throw error;
    }
}

async function initializeMsal() {
    try {
        await msalInstance.initialize();
        console.log("MSAL inizializzato con successo.");
    } catch (error) {
        console.error("Errore durante l'inizializzazione di MSAL:", error);
    }
}

initializeMsal(); // Richiama l'inizializzazione



class AuthService {

    // async loginWithMicrosoft() {
    //     try {
    //         console.log("Tentativo di login con Microsoft");
    //         const response = await msalInstance.loginPopup();
    //         console.log("Risposta ottenuta:", response);
    
    //         if (response && response.accessToken) {
    //             const token = response.accessToken;
    //             sessionStorage.setItem("user", JSON.stringify(response.account));
    //             sessionStorage.setItem("token", token);
    //             return response;
    //         } else {
    //             console.error("Login con Microsoft fallito: Nessun accessToken trovato");
    //             throw new Error("Login con Microsoft fallito: Nessun accessToken trovato");
    //         }
    //     } catch (error) {
    //         console.error("Errore durante il login con Microsoft:", error);
    //         alert("Errore durante il login con Microsoft. Verifica le impostazioni o riprova.");
    //         throw error;
    //     }
    // }


    

    async loginWithMicrosoft() {
        try {
            console.log("Tentativo di login con Microsoft...");
            const loginResponse = await msalInstance.loginPopup({
                scopes: ["Mail.Send", "User.Read", "Mail.ReadWrite", "Mail.Send.Shared"], 
            });

            const tokenResponse = await msalInstance.acquireTokenSilent({
                scopes: ["Mail.Send", "User.Read", "Mail.ReadWrite", "Mail.Send.Shared"], 
                account: loginResponse.account,
            });


            if (tokenResponse && tokenResponse.accessToken) {
                const user = {
                    username: loginResponse.account.username,
                    email: loginResponse.account.homeAccountId,
                };
    
                return { user, accessToken: tokenResponse.accessToken };
            } else {
                throw new Error("Accesso Microsoft fallito: Nessun access token trovato.");
            }
        } catch (error) {
            console.error("Errore durante il login con Microsoft:", error);
            alert(`Errore durante il login: ${error.message}`);
        }
    }
    
    
    login(username, password) {
        return axios
            .post(API_LOGIN + "/signin", { username, password })
            .then(response => {
                if (response.data) {
                    const token = response.data.token;
                    const decodedToken = JSON.parse(atob(token.split('.')[1]));
                    const expirationTime = decodedToken.exp
                    sessionStorage.setItem("user", JSON.stringify(response.data));
                    sessionStorage.setItem("expiraion-time", expirationTime);
                    return response.data;
                } else {
                    throw new Error("Autentication failed");
                }
            })
            .catch(
                error => {
                    throw error;
                });
    }

    register( username, password, nome, cognome, pIva, ragioneSociale, personaContatto, emailPersonaContatto, telefono, commerciale, lingua) {
        return axios
            .post(API_REGISTER + "/signup", { username, password, nome, cognome, pIva, ragioneSociale, personaContatto, emailPersonaContatto, telefono, commerciale, lingua })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    throw new Error("Register failed");
                }
            })
            .catch(
                error => {
                    throw error;
                });
    }

    logout() {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const token = user?.token;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        return axios
            .post(API_LOGOUT, {}, config)
            .then(response => {
                if (response.data) {
                    sessionStorage.removeItem("user");
                }
                return response.data;
            })
    }
    getCurrentUser() {
        const user = JSON.parse(sessionStorage.getItem('user'));
        return user;
    }
    isAuthenticated() {
        const user = this.getCurrentUser();
        return user && user.token ? true : false;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService();
